export const ALLOWED_DOCUMENT_FILE_TYPES = {
  '.pdf': ['application/pdf'],
  '.jpg': ['image/jpeg'],
  '.jpeg': ['image/jpeg'],
  '.png': ['image/png'],
  '.tif': ['image/tiff'],
  '.bmp': ['image/bmp', 'image/x-ms-bmp'],
  '.heic': ['image/heic', 'image/heif'],
  '.xls': [
    'application/vnd.ms-excel',
    'application/msexcel',
    'application/x-msexcel',
    'application/x-ms-excel',
    'application/xls'
  ],
  '.xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
}

export const DOCUMENT_UPLOAD_ACCEPT = Object.keys(ALLOWED_DOCUMENT_FILE_TYPES).join(',')

export const validateDocumentFile = (file) => {
  if (!file) return 'Debes seleccionar un archivo.'

  const filename = String(file.name || '')
  const lastDotIndex = filename.lastIndexOf('.')
  const extension = lastDotIndex >= 0 ? filename.slice(lastDotIndex).toLowerCase() : ''

  if (!ALLOWED_DOCUMENT_FILE_TYPES[extension]) {
    return 'Solo se permiten archivos PDF, imágenes autorizadas y planillas XLS/XLSX.'
  }

  const fileType = String(file.type || '').toLowerCase()
  if (!fileType) {
    return 'No se pudo identificar el tipo MIME del archivo.'
  }

  if (!ALLOWED_DOCUMENT_FILE_TYPES[extension].includes(fileType)) {
    return 'El tipo MIME del archivo no coincide con su extensión.'
  }

  return null
}

export const filterValidDocumentFiles = (files) => {
  const validFiles = []
  const errors = []

  files.forEach((file) => {
    const error = validateDocumentFile(file)

    if (error) {
      errors.push(`${file.name}: ${error}`)
      return
    }

    validFiles.push(file)
  })

  return { validFiles, errors }
}
